import classNames from "classnames";
import classes from "./SectionContent.module.scss";
import { DropDown } from "../../../DropDown/DropDown";
import { crossIcon } from "../../../../../assets/icons/index";
import { FC, useEffect, useMemo, useRef, useState } from "react";
import * as React from "react";
import { CustomTextField } from "../../../CustomTextField/CustomTextField";
import { SearchTextField } from "../../../SearchTextField/SearchTextField";
import { Button } from "../../../Button/Button";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import CustomRadio from "../../../CustomRadio/CustomRadio";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  ParentCategoryOption,
  useGetCategoriesTopicsForModal,
} from "../../../../../hooks/Admin/CategoriesAndServisesTable/useGetCategoriesTopicsForModal";
import { useCreateCategory } from "../../../../../hooks/Admin/CategoriesAndServisesTable/useCreateCategory";
import { useEditCategory } from "../../../../../hooks/Admin/CategoriesAndServisesTable/useEditCategory";
import BranchQueueTreeSelect from "../../../BranchQueueTreeSelect/BranchQueueTreeSelect";
import {
  CategoriesTableType,
  categoryServiceItemInModal,
  categoryServiceType,
  ModalContentProps,
  QueueItem,
  SectionOrServiceForTable,
} from "../../../../../types/Admin/CategoriesTopicsTypes";
import { useGetAllCategoriesTopics } from "../../../../../hooks/Admin/CategoriesAndServisesTable/useGetAllCategoriesTopics";
import { ModalMode, SectionOrCategory } from "../../../../../types/enums";
import modalBase from "../../../../ModalBase/ModalBase.module.scss";
import { useAdminQueueIdsFilter } from "../../../../../hooks/Admin/useAdminQueueIdsFilter";
import { ItemIconEditor } from "../../../ItemIconEditor/ItemIconEditor";
import { ItemIconSettings } from "../../../../../types/Admin/ItemIconTypes";
import { defaultItemIconSettings } from "../../../../../utils/mediaBackground";
import { mapItemIconFields } from "../../../../../utils/Admin/CategoriesAndServicesTable/mapItemIconFields";
import { mapChildrenIconFields } from "../../../../../utils/Admin/CategoriesAndServicesTable/mapChildrenIconFields";
import { resolveIconSettingsForEdit } from "../../../../../utils/Admin/CategoriesAndServicesTable/resolveIconSettingsForEdit";
import { resolveChildrenIconSettingsForEdit } from "../../../../../utils/Admin/CategoriesAndServicesTable/resolveChildrenIconSettingsForEdit";
import { resolveBindingsForEdit } from "../../../../../utils/Admin/CategoriesAndServicesTable/resolveBindingsForEdit";
import { useUploadCategoryIcon } from "../../../../../hooks/Admin/CategoriesAndServisesTable/useUploadCategoryIcon";
import { useUploadCategoryChildrenIcon } from "../../../../../hooks/Admin/CategoriesAndServisesTable/useUploadCategoryChildrenIcon";

const topLevel: ParentCategoryOption = { nameRu: "Верхний уровень" };
export const SectionContent: FC<ModalContentProps> = ({
  isActive,
  selectedRadioValue,
  handleRadioChange,
  setActiveModal,
  modalDataFromTable,
  modalMode,
}) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [startTime, setStartTime] = useState("10:00");
  const [endTime, setEndTime] = useState("18:00");

  const { createCategory, isLoadingCreatedCategory } = useCreateCategory(() =>
    setActiveModal(false),
  );
  const { editCategory, isLoadingCategoryEditing } = useEditCategory(
    setActiveModal,
    modalDataFromTable.id,
  );
  const initializedForIdRef = useRef<number | null>(null);
  const iconLoadedForIdRef = useRef<number | null>(null);
  const selectedQueueIdsRef = useRef<number[]>([]);
  const selectedBranchIdsRef = useRef<number[]>([]);

  const applyBindings = (branchIds: number[], queueIds: number[]) => {
    selectedBranchIdsRef.current = branchIds;
    selectedQueueIdsRef.current = queueIds;
    if (branchIds.length > 0) {
      setSelectedBranchIds(branchIds);
    }
    if (queueIds.length > 0) {
      setSelectedQueueIds(queueIds);
    }
  };
  const { allCategoriesTopicsResp, isAllCategoriesTopicsReceived } =
    useGetAllCategoriesTopics();
  const [addedTopics, setAddedTopics] = useState<categoryServiceType[]>([]);
  const [allTopics, setAllTopics] = useState<categoryServiceType[]>([]);
  const [startParentCategoryItems, setParentCategoryItems] = useState<
    ParentCategoryOption[]
  >([topLevel]);
  const [currentParentCategoryItems, setCurrentParentCategoryItems] = useState<
    ParentCategoryOption[]
  >([]);

  const [dropDownItem, setDropDownItem] =
    useState<ParentCategoryOption>(topLevel);
  const [selectedQueueIds, setSelectedQueueIds] = useState<number[]>([]);
  const [selectedBranchIds, setSelectedBranchIds] = useState<number[]>([]);
  const [isBindingTouched, setIsBindingTouched] = useState(false);
  const [iconSettings, setIconSettings] = useState<ItemIconSettings>(
    defaultItemIconSettings,
  );
  const [childrenIconSettings, setChildrenIconSettings] =
    useState<ItemIconSettings>(defaultItemIconSettings);
  const { queueIdsFilter } = useAdminQueueIdsFilter();
  const { uploadCategoryIcon, isUploadCategoryIconLoading } =
    useUploadCategoryIcon();
  const { uploadCategoryChildrenIcon, isUploadCategoryChildrenIconLoading } =
    useUploadCategoryChildrenIcon();
  const { categoriesAndTopics, isAllCategoriesAndTopicsReceived } =
    useGetCategoriesTopicsForModal(topLevel);

  // На `/categories-topics` для модалки признак активности услуги не приходит.
  // Поэтому используем `/categories-topics/view` и скрываем неактивные услуги
  // (то есть "удалённые" в UI сценарии).
  const activeServiceIds = React.useMemo(() => {
    const services = allCategoriesTopicsResp?.services ?? [];
    return new Set<number>(
      services
        .filter((s: any) => Boolean(s?.isActiveTopic))
        .map((s: any) => s?.id)
        .filter((id: any): id is number => typeof id === "number"),
    );
  }, [allCategoriesTopicsResp?.services]);

  const topicsByBranchQueue = React.useMemo(() => {
    const topics = categoriesAndTopics?.topics ?? [];
    if (selectedBranchIds.length === 0 && selectedQueueIds.length === 0)
      return [];
    return topics.filter((row: categoryServiceItemInModal) => {
      const branchMatch =
        selectedBranchIds.length === 0 ||
        (row.branchIds?.length &&
          row.branchIds.some((b) => selectedBranchIds.includes(b)));
      const queueMatch =
        selectedQueueIds.length === 0 ||
        (row.queueIds?.length &&
          row.queueIds.some((q) => selectedQueueIds.includes(q)));
      const activeMatch =
        !isAllCategoriesTopicsReceived ||
        (row.id != null && activeServiceIds.has(row.id));
      return Boolean(branchMatch && queueMatch && activeMatch);
    });
  }, [
    categoriesAndTopics?.topics,
    selectedBranchIds,
    selectedQueueIds,
    activeServiceIds,
    isAllCategoriesTopicsReceived,
  ]);

  const parentCategoriesByBranchQueue = React.useMemo(() => {
    const items = startParentCategoryItems ?? [topLevel];
    if (selectedBranchIds.length === 0 && selectedQueueIds.length === 0) {
      return items;
    }

    return items.filter((row: ParentCategoryOption) => {
      if (row?.id == null) return true; // "Верхний уровень"
      // Требование: показывать категории выбранных очередей.
      // Если очереди выбраны — фильтруем ТОЛЬКО по ним (филиалы не ограничивают список).
      if (selectedQueueIds.length > 0) {
        return Boolean(
          row.queueIds?.length &&
          row.queueIds.some((q: number) => selectedQueueIds.includes(q)),
        );
      }

      // Если очереди не выбраны, но выбраны филиалы — фильтруем по филиалам.
      return Boolean(
        selectedBranchIds.length === 0 ||
        (row.branchIds?.length &&
          row.branchIds.some((b: number) => selectedBranchIds.includes(b))),
      );
    });
  }, [startParentCategoryItems, selectedBranchIds, selectedQueueIds]);

  function getQueuesToCheck(): number[] {
    if (selectedQueueIds.length > 0) {
      return selectedQueueIds;
    }
    return modalDataFromTable.queues?.map((queue) => queue.id) ?? [];
  }

  function hasSharedQueue(
    categoryQueues: QueueItem[] | undefined,
    queuesToCheck: number[],
  ): boolean {
    const categoryQueueIds = categoryQueues?.map((queue) => queue.id) ?? [];
    return categoryQueueIds.some((queueId) => queuesToCheck.includes(queueId));
  }

  function checkIsUniqueInQueues(
    value: string | undefined,
    getExistingValue: (obj: CategoriesTableType) => string | undefined,
  ): boolean {
    if (!isAllCategoriesTopicsReceived || !value?.trim()) {
      return true;
    }

    const normalizedValue = value.trim().toLowerCase();
    const queuesToCheck = getQueuesToCheck();
    if (queuesToCheck.length === 0) {
      return true;
    }

    return !allCategoriesTopicsResp.sections.some(
      (obj: CategoriesTableType) => {
        if (modalMode === ModalMode.Edit && obj.id === modalDataFromTable.id) {
          return false;
        }

        const existingValue = getExistingValue(obj);
        if (typeof existingValue !== "string" || !existingValue.trim()) {
          return false;
        }

        return (
          existingValue.trim().toLowerCase() === normalizedValue &&
          hasSharedQueue(obj.queues, queuesToCheck)
        );
      },
    );
  }

  function checkIsNameUnique(
    nameField: string,
    value: string | undefined,
  ): boolean {
    return checkIsUniqueInQueues(
      value,
      (obj) =>
        obj[nameField as keyof CategoriesTableType] as string | undefined,
    );
  }

  const ModalSectionSchema = useMemo(
    () =>
      yup.object({
        inputTextRu: yup
          .string()
          .required("Необходимо заполнить поле")
          .test(
            "unique-nameRu",
            "Такое наименование уже существует в выбранной очереди",
            (value) => checkIsNameUnique("nameRu", value),
          )
          .test("no-empty-spaces", "Введите текст", (value) => {
            return !/^\s+$/.test(value);
          }),
        inputTextEn: yup
          .string()
          .required("Необходимо заполнить поле")
          .test(
            "unique-nameEn",
            "Такое наименование уже существует в выбранной очереди",
            (value) => checkIsNameUnique("nameEn", value),
          )
          .test("no-empty-spaces", "Введите текст", (value) => {
            return !/^\s+$/.test(value);
          }),
        inputTextBy: yup
          .string()
          .required("Необходимо заполнить поле")
          .test(
            "unique-nameBe",
            "Такое наименование уже существует в выбранной очереди",
            (value) => checkIsNameUnique("nameBe", value),
          )
          .test("no-empty-spaces", "Введите текст", (value) => {
            return !/^\s+$/.test(value);
          }),
        searchText: yup.string(),
      }),
    [
      isAllCategoriesTopicsReceived,
      allCategoriesTopicsResp,
      selectedQueueIds,
      modalMode,
      modalDataFromTable.id,
      modalDataFromTable.queues,
    ],
  );

  type FormData = yup.InferType<typeof ModalSectionSchema>;
  const {
    register,
    setValue,
    watch,
    handleSubmit,
    reset,
    trigger,
    setError,
    formState: { errors, isSubmitted },
  } = useForm<FormData>({
    resolver: yupResolver(ModalSectionSchema),
    mode: "onSubmit",
    reValidateMode: "onChange",
    defaultValues: {
      inputTextRu: "",
      inputTextEn: "",
      inputTextBy: "",
      searchText: "",
    },
  });

  useEffect(() => {
    if (!isSubmitted) return;
    void trigger(["inputTextRu", "inputTextEn", "inputTextBy"]);
  }, [selectedQueueIds, trigger, isSubmitted]);

  useEffect(() => {
    if (!isActive) {
      setMenuOpen(false);
    }
  }, [isActive]);

  useEffect(() => {
    // Для списка "Родительский раздел" используем данные из `/categories-topics/view`,
    // т.к. там гарантированно есть связи с филиалами/очередями.
    if (isAllCategoriesTopicsReceived && allCategoriesTopicsResp?.sections) {
      const mapped: ParentCategoryOption[] =
        allCategoriesTopicsResp.sections.map((s: any) => ({
          id: s.id,
          nameRu: s.nameRu,
          branchIds: s.branches?.map((b: any) => b.id),
          queueIds: s.queues?.map((q: any) => q.id),
        }));
      setParentCategoryItems([topLevel, ...mapped]);
    }
  }, [isAllCategoriesTopicsReceived, allCategoriesTopicsResp?.sections]);

  useEffect(() => {
    let finalAddedTopicsForIds: categoryServiceType[] = [];

    if (modalDataFromTable && modalMode === ModalMode.Edit) {
      const topics = modalDataFromTable.topics;
      const topicsFromRow: categoryServiceType[] =
        topics && topics.length > 0
          ? topics
          : (modalDataFromTable.subRows?.map((r) => ({
              id: r.id,
              nameRu: r.nameRu,
            })) ?? []);

      finalAddedTopicsForIds = isAllCategoriesTopicsReceived
        ? topicsFromRow.filter(
            (t) => t.id != null && activeServiceIds.has(t.id),
          )
        : topicsFromRow;

      setAddedTopics(finalAddedTopicsForIds);
    }

    if (isAllCategoriesAndTopicsReceived && topicsByBranchQueue?.length >= 0) {
      const addedIds =
        modalMode === ModalMode.Edit
          ? new Set(
              finalAddedTopicsForIds
                .map((t) => t.id)
                .filter((id): id is number => id != null),
            )
          : new Set<number>();
      const updatedTopics = topicsByBranchQueue.filter(
        (topic: categoryServiceType) =>
          topic.id != null && !addedIds.has(topic.id),
      );
      modalMode === ModalMode.Edit && addedIds.size > 0
        ? setAllTopics(updatedTopics)
        : setAllTopics(topicsByBranchQueue);
    }

    if (modalDataFromTable && !modalDataFromTable.isParentCategory) {
      setDropDownItem(modalDataFromTable.parentCategory);
    } else {
      setDropDownItem(topLevel);
    }
  }, [
    modalDataFromTable,
    isAllCategoriesAndTopicsReceived,
    modalMode,
    topicsByBranchQueue,
    activeServiceIds,
    isAllCategoriesTopicsReceived,
  ]);

  useEffect(() => {
    const filteredItems = filteredParentCategoryItems(
      parentCategoriesByBranchQueue,
    );
    setCurrentParentCategoryItems(filteredItems);
  }, [modalDataFromTable, parentCategoriesByBranchQueue]);

  useEffect(() => {
    // если текущий выбранный родитель не подходит под новую привязку — сбрасываем на "Верхний уровень"
    if (
      dropDownItem?.id != null &&
      currentParentCategoryItems.length > 0 &&
      !currentParentCategoryItems.some((x) => x.id === dropDownItem.id)
    ) {
      setDropDownItem(topLevel);
    }
  }, [currentParentCategoryItems, dropDownItem?.id]);

  function filteredParentCategoryItems(
    categoriesArr: ParentCategoryOption[],
  ): ParentCategoryOption[] {
    if (modalDataFromTable) {
      return categoriesArr.filter(
        (category: ParentCategoryOption) =>
          category.id !== modalDataFromTable.id,
      );
    }
    return categoriesArr;
  }

  const filterServices = (searchValue: string): void => {
    const addedIds = new Set(
      addedTopics.map((t) => t.id).filter((id): id is number => id != null),
    );
    const filteredServices: categoryServiceItemInModal[] =
      topicsByBranchQueue?.filter(
        (service: categoryServiceItemInModal) =>
          service.nameRu.toLowerCase().includes(searchValue.toLowerCase()) &&
          !addedIds.has(service.id),
      ) ?? [];
    setAllTopics(filteredServices);
  };

  useEffect(() => {
    if (modalDataFromTable && modalDataFromTable.startFinishWork) {
      const entityId = modalDataFromTable.id;
      const isNewEntity = initializedForIdRef.current !== entityId;

      if (isNewEntity) {
        initializedForIdRef.current = entityId;
        iconLoadedForIdRef.current = null;
        const timeArr = modalDataFromTable.startFinishWork.split("-");
        setStartTime(timeArr[0]);
        setEndTime(timeArr[1]);
        setValue("inputTextRu", modalDataFromTable.nameRu);
        setValue("inputTextEn", modalDataFromTable.nameEn);
        setValue("inputTextBy", modalDataFromTable.nameBe);
        setIsBindingTouched(false);
      }

      if (!isBindingTouched) {
        const data = modalDataFromTable as SectionOrServiceForTable;
        const bindings = resolveBindingsForEdit(
          data,
          allCategoriesTopicsResp,
          data.radioType === "service" ? "service" : "section",
        );
        applyBindings(bindings.branchIds, bindings.queueIds);
      }
    } else if (modalMode !== ModalMode.Edit) {
      initializedForIdRef.current = null;
      iconLoadedForIdRef.current = null;
      handleResetForm();
    }
  }, [
    modalDataFromTable?.id,
    modalMode,
    allCategoriesTopicsResp,
    isBindingTouched,
  ]);

  useEffect(() => {
    if (
      modalMode !== ModalMode.Edit ||
      !modalDataFromTable?.id ||
      !allCategoriesTopicsResp
    ) {
      return;
    }

    if (iconLoadedForIdRef.current === modalDataFromTable.id) {
      return;
    }

    iconLoadedForIdRef.current = modalDataFromTable.id;
    const data = modalDataFromTable as SectionOrServiceForTable;
    setIconSettings(
      resolveIconSettingsForEdit(
        data,
        allCategoriesTopicsResp,
        data.radioType === "service" ? "service" : "section",
      ),
    );
    setChildrenIconSettings(
      resolveChildrenIconSettingsForEdit(
        data,
        allCategoriesTopicsResp,
        data.radioType === "service" ? "service" : "section",
      ),
    );
  }, [modalDataFromTable?.id, modalMode, allCategoriesTopicsResp]);

  function handleResetForm() {
    reset();
    setStartTime("10:00");
    setEndTime("18:00");
    setAddedTopics([]);
    selectedQueueIdsRef.current = [];
    selectedBranchIdsRef.current = [];
    setSelectedQueueIds([]);
    setSelectedBranchIds([]);
    setIconSettings(defaultItemIconSettings);
    setChildrenIconSettings(defaultItemIconSettings);
    setMenuOpen(false);
    setIsBindingTouched(false);
  }

  function addServiceToArr(item: categoryServiceType): void {
    if (
      !addedTopics.some(
        (service: categoryServiceType): boolean => service.id === item.id,
      )
    ) {
      setAddedTopics((prevState: categoryServiceType[]) => [
        ...prevState,
        item,
      ]);
    }
  }

  function addRemovedServiceToArr(item: categoryServiceType): void {
    if (
      isAllCategoriesTopicsReceived &&
      item.id != null &&
      !activeServiceIds.has(item.id)
    ) {
      return;
    }
    if (
      !allTopics.some(
        (service: categoryServiceType): boolean => service.id === item.id,
      )
    ) {
      setAllTopics((prevState: categoryServiceType[]) => [...prevState, item]);
    }
  }

  function removeServiceById(id: number): void {
    setAddedTopics((prevState: categoryServiceType[]) =>
      prevState.filter((service: categoryServiceType) => service.id !== id),
    );
  }

  function removeSelectedServiceById(id: number): void {
    setAllTopics((prevState: categoryServiceType[]) =>
      prevState.filter((service: categoryServiceType) => service.id !== id),
    );
  }

  function validateUniqueFields(data: FormData): boolean {
    const uniqueChecks: Array<{
      field: keyof FormData;
      message: string;
      isValid: boolean;
    }> = [
      {
        field: "inputTextRu",
        message: "Такое наименование уже существует в выбранной очереди",
        isValid: checkIsNameUnique("nameRu", data.inputTextRu),
      },
      {
        field: "inputTextEn",
        message: "Такое наименование уже существует в выбранной очереди",
        isValid: checkIsNameUnique("nameEn", data.inputTextEn),
      },
      {
        field: "inputTextBy",
        message: "Такое наименование уже существует в выбранной очереди",
        isValid: checkIsNameUnique("nameBe", data.inputTextBy),
      },
    ];

    let isValid = true;
    for (const check of uniqueChecks) {
      if (!check.isValid) {
        setError(check.field, { type: "manual", message: check.message });
        isValid = false;
      }
    }

    return isValid;
  }

  const onSubmit: SubmitHandler<FormData> = async (formData: FormData) => {
    const { inputTextRu, inputTextEn, inputTextBy } = formData;
    const branchIds = [...selectedBranchIdsRef.current];
    const queueIds = [...selectedQueueIdsRef.current];
    const isBindingValid = branchIds.length > 0 && queueIds.length > 0;
    if (!isBindingValid) {
      setIsBindingTouched(true);
      return;
    }
    if (!validateUniqueFields(formData)) {
      return;
    }
    const topicIds = addedTopics
      .map((service: categoryServiceType) => service.id)
      .filter((id): id is number => id != null);
    const categoryData = {
      nameRu: inputTextRu,
      nameBe: inputTextBy,
      nameEn: inputTextEn,
      isParentCategory: dropDownItem && dropDownItem?.id ? false : true,
      ...(dropDownItem &&
        dropDownItem?.id && { parentCategoryId: dropDownItem?.id }),
      topics: topicIds,
      branchIds,
      queueIds,
      startWork: startTime,
      endWork: endTime,
      ...mapItemIconFields(iconSettings),
      ...mapChildrenIconFields(childrenIconSettings),
    };
    if (startTime && endTime) {
      if (modalMode === ModalMode.Edit) {
        if (editCategory) {
          editCategory(categoryData);
        }
      } else {
        if (createCategory) {
          createCategory(categoryData);
        }
      }
    }
  };

  const isBindingValid =
    selectedBranchIds.length > 0 && selectedQueueIds.length > 0;
  const showBindingError = isBindingTouched && !isBindingValid;

  return (
    <form className={classes.sectionForm}>
      <h2 className={modalBase.title}>Категория / услуга</h2>
      <div className={modalBase.scrollArea}>
        <div className={classes.sectionContent}>
          {(isLoadingCreatedCategory || isLoadingCategoryEditing) && (
            <div className={classes.load}>
              <div className={classes.loadContent}>
                <p>Cохранение...</p>
              </div>
            </div>
          )}
          <div className={classes.card}>
            <div className={classes.radioContainer}>
              <div className={classes.radio}>
                <CustomRadio
                  id={"section"}
                  value={"section"}
                  checked={selectedRadioValue === "section"}
                  onChange={handleRadioChange}
                  label={"Категория"}
                  disabled={
                    modalMode === ModalMode.Edit &&
                    modalDataFromTable.radioType === SectionOrCategory.Service
                  }
                />
              </div>
              <div className={classes.radio}>
                <CustomRadio
                  id={"service"}
                  value={"service"}
                  checked={selectedRadioValue === "service"}
                  onChange={handleRadioChange}
                  label={"Услуга"}
                  disabled={
                    modalMode === ModalMode.Edit &&
                    modalDataFromTable.radioType === SectionOrCategory.Section
                  }
                />
              </div>
            </div>
            <h3 className={classes.sectionTitle}>Привязка</h3>
            <BranchQueueTreeSelect
              selectedBranchIds={selectedBranchIds}
              selectedQueueIds={selectedQueueIds}
              onBranchChange={(ids) => {
                selectedBranchIdsRef.current = ids;
                setSelectedBranchIds(ids);
                setIsBindingTouched(true);
              }}
              onQueueChange={(ids) => {
                selectedQueueIdsRef.current = ids;
                setSelectedQueueIds(ids);
                setIsBindingTouched(true);
              }}
              className={classes.queuesBlock}
              queueIdsFilter={queueIdsFilter}
            />
            {showBindingError && (
              <p className={classes.timeError}>
                Выберите привязку к филиалу и очереди
              </p>
            )}
            <h3 className={classes.sectionTitle}>Родительский раздел</h3>
            <div className={classes.chaptersDropdown}>
              <DropDown
                isMenuOpen={isMenuOpen}
                setMenuOpen={setMenuOpen}
                label={"Родительский раздел"}
                activeService={dropDownItem?.nameRu || topLevel.nameRu}
              >
                {currentParentCategoryItems.map((item) => (
                  <li
                    key={item.nameRu}
                    className={classes.serviceItem}
                    onClick={(): void => {
                      setDropDownItem(item);
                      setMenuOpen(false);
                    }}
                  >
                    <span>{item.nameRu}</span>
                  </li>
                ))}
              </DropDown>
            </div>
          </div>
          <div className={classes.card}>
            <h3 className={classes.sectionTitle}>Наименования</h3>
            <div className={classes.nameRu}>
              <CustomTextField
                {...register("inputTextRu")}
                name="inputTextRu"
                value={watch("inputTextRu")}
                labelName={"Наименование RU"}
                errorMessage={
                  isSubmitted ? errors.inputTextRu?.message : undefined
                }
              />
            </div>
            <div className={classes.nameEn}>
              <CustomTextField
                {...register("inputTextEn")}
                name="inputTextEn"
                value={watch("inputTextEn")}
                labelName={"Наименование EN"}
                errorMessage={
                  isSubmitted ? errors.inputTextEn?.message : undefined
                }
              />
            </div>
            <div className={classes.nameBe}>
              <CustomTextField
                {...register("inputTextBy")}
                name="inputTextBy"
                value={watch("inputTextBy")}
                labelName={"Наименование BY"}
                errorMessage={
                  isSubmitted ? errors.inputTextBy?.message : undefined
                }
              />
            </div>
          </div>
          <div className={classes.card}>
            <h3 className={classes.sectionTitle}>Иконка</h3>
            <ItemIconEditor
              idPrefix="category"
              value={iconSettings}
              onChange={setIconSettings}
              isUploading={isUploadCategoryIconLoading}
              onUpload={(file) => uploadCategoryIcon(file)}
            />
          </div>
          <div className={classes.card}>
            <h3 className={classes.sectionTitle}>Иконка для детского режима</h3>
            <ItemIconEditor
              idPrefix="category-children"
              value={childrenIconSettings}
              onChange={setChildrenIconSettings}
              isUploading={isUploadCategoryChildrenIconLoading}
              onUpload={(file) => uploadCategoryChildrenIcon(file)}
            />
          </div>
          <div className={classes.servicesRow}>
            <div className={classNames(classes.card, classes.searchContainer)}>
              <h3 className={classes.sectionTitle}>Добавить услуги</h3>
              <div className={classes.cardBody}>
                <SearchTextField
                  {...register("searchText")}
                  name="searchText"
                  placeholder={"Введите название"}
                  clearInput={(): void => {
                    setValue("searchText", "");
                    filterServices("");
                  }}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    filterServices(e.target.value)
                  }
                >
                  {allTopics?.map((item) => (
                    <div
                      key={item.id}
                      className={classes.serviceItem}
                      onClick={() => {
                        addServiceToArr(item);
                        removeSelectedServiceById(item.id);
                      }}
                    >
                      <span>{item.nameRu}</span>
                    </div>
                  ))}
                </SearchTextField>
              </div>
            </div>
            <div className={classNames(classes.card, classes.addedServices)}>
              <h3 className={classes.sectionTitle}>Добавленные услуги</h3>
              <div className={classes.cardBody}>
                <CustomTextField labelName={""} disabled={true}>
                  {addedTopics.map((item) => (
                    <div
                      key={item.id}
                      className={classes.addedServiceItem}
                      onClick={() => {
                        removeServiceById(item.id);
                        addRemovedServiceToArr(item);
                      }}
                    >
                      <div className={classes.crossIcon}>
                        <img src={crossIcon} alt={"cross"} />
                      </div>
                      <span>{item.nameRu}</span>
                    </div>
                  ))}
                </CustomTextField>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classNames(modalBase.footer, classes.buttonsContainer)}>
        <Button
          content={"отмена"}
          btnStyle={"white"}
          onClick={() => setActiveModal(false)}
        />
        <Button
          content={"сохранить"}
          btnStyle={"blue"}
          onClick={() => {
            setIsBindingTouched(true);
            selectedQueueIdsRef.current = selectedQueueIds;
            selectedBranchIdsRef.current = selectedBranchIds;
            handleSubmit(onSubmit)();
          }}
          isLoading={isLoadingCreatedCategory || isLoadingCategoryEditing}
        />
      </div>
    </form>
  );
};
